export default __webpack_public_path__ + "static/media/bird.6af376d7.svg";